import {gsap} from "gsap";
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {SplitText} from 'gsap/SplitText'

gsap.registerPlugin(ScrollTrigger, SplitText)

export const splitTextByLine = (textContainer, forceLineHeight) => {

  if (textContainer && textContainer.classList.contains('uppercase'))
    forceLineHeight = false;

  const
    toSplitText = new SplitText(textContainer, {
      type: 'lines, words',
      linesClass: 'text__line',
      wordsClass: 'text__word'
    }),
    lines = toSplitText.lines,
    words = toSplitText.words

  gsap.set(lines, {
    overflow: 'hidden',
    lineHeight: forceLineHeight !== false ? 1.22 : null,
    opacity: 1
  })

  gsap.set(words, {
    yPercent: 100,
    onComplete: () => {
      gsap.set(textContainer, {
        opacity: 1,
      })
    }
  })

  return {
    lines: lines,
    words: words,
  }
}
